import moment       from "moment";
import { apiTypes } from 'shared/consts/handbooksApiTypes';

const config = {
  schema: '',
  table: 'drivers',
  title: 'ТС-водитель',
  apiType: apiTypes.REPORT_API,
  elemsOnPage: 100,
  connections: {
    names: {
      apiType: apiTypes.DEFAULT,
      schema: 'mgt',
      table: 'Driver',
      fields: ['table_number', 'driver_id', 'first_name', 'middle_name', 'last_name'],
      autocomplete: true,
      format: (elem: any) => `${elem['last_name']} ${elem['first_name']}${elem['middle_name'] ? ' ' + elem['middle_name'] : ''} (таб. №${elem['table_number']})`,
      index: 'driver_id',
      type: 'list',
    },
    vehicles: {
      apiType: apiTypes.REPORT_API,
      table: 'vehicles',
      fields: ['depot_number'],
      format: (elem: any) => elem['name'],
      index: 'id',
      autocomplete: true,
    },
  },
  fields: [
    {
      name: 'driver_id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px',
      disableFilter: true
    },
    {
      name: 'name',
      title: 'Водитель',
      type: 'text',
      required: false,
      connection: 'names'
    },
    {
      name: 'vehicle_id',
      title: 'Гаражный номер ТС',
      type: 'number',
      required: false,
      connection: 'vehicles',
      id_type: 'number',
    },
    {
      name: 'start_time',
      title: 'Дата/время начала работы',
      type: 'datetime',
      required: true,
      disableFilter: true,
    },
    {
      name: 'end_time',
      title: 'Дата/время окончания работы',
      type: 'datetime',
      validate: (value: number, row: any) =>
        !moment(value).isBefore(row['start_time']),
      validateError: 'Дата окончания не может быть меньше даты ввода',
      required: true,
      disableFilter: true,
    },
  ],
  newTemplate: {
    driver_id: null,
    name: null,
    vehicle_id: null,
    start_time: null,
    end_time: null,
  },
  updateField: 'update_date',
  makeIdOnInsert: true,
  defaultSort: {
    field: 'driver_id',
    direction: 'desc',
  },
  import: {
    header: [
      {
        title: 'driver_id',
        field: 'driver_id',
      },{
        title: 'name',
        field: 'name',
      },
      {
        title: 'vehicle_id',
        field: 'vehicle_id',
      },
      {
        title: 'start_time',
        field: 'start_time',
      },
      {
        title: 'end_time',
        field: 'end_time',
      },
    ],
    example: `1;1;1;1748515896;1748519496`,
  },
};

export default config;
